// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"8":"dict-dict-ar-js","283":"dict-dict-uk-js","427":"dict-dict-es-js","492":"dict-dict-de-js","599":"dict-dict-pt-js","894":"dict-dict-ru-js"}[chunkId] || chunkId) + "." + {"8":"1478d25c","283":"d41089c2","427":"3f2c0c01","453":"18b013e7","492":"3dd2ad34","599":"9443f661","894":"1548b827"}[chunkId] + ".chunk.js";
};